import { Ticket } from '../types/ticket';

// Matches the fallback written by addTicket.ts when no description is provided.
// Treated as "no real description" so it doesn't mask an older, meaningful one.
const VEHICLE_INFO_FALLBACK = 'Not Provided';

/**
 * Returns the most recent *meaningful* vehicle description across the plate's
 * full history, so the description persists for a plate even after older tickets
 * fall outside the lookup window.
 *
 * Tickets are expected newest-first (as returned by findTickets). Empty strings
 * and the `'Not Provided'` fallback are skipped in favour of an earlier real
 * description. Returns '' when nothing meaningful is found.
 */
export function getLatestVehicleInfo(tickets: Ticket[]): string {
	for (const ticket of tickets) {
		const info = ticket.vehicleInfo?.trim();
		if (info && info !== VEHICLE_INFO_FALLBACK) {
			return info;
		}
	}
	return '';
}
